import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": ".834",
  d: "M13.032 32v-8.516h10.064"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": ".834",
  d: "M15.741 27.742v-1.935h1.936M20 27.742v-1.935h1.936M15.741 32v-1.935h1.936M20 32v-1.935h1.936M14.967 20.773v2.71M18.452 20.773v2.71M21.936 20.773v2.71M25.42 32V16.129M28.129 12.645v-.774h3.87v3.87h-3.483V32M25.42 8v4.646M8 15.742h17.42l-1.936-2.71H10.323z"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": ".834",
  d: "M16.516 13.032 25.419 8 32 11.871M9.16 20.387a1.162 1.162 0 1 0 1.606-1.075.75.75 0 0 1-.444-.698v-2.873"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }